import React from "react";

export const MetricRow = ({ items }) => (
  <div className="mx-auto grid max-w-[1440px] grid-cols-1 gap-px overflow-hidden border border-[#EDE4D3]/12 bg-[#EDE4D3]/12 sm:grid-cols-2 lg:grid-cols-4">
    {items.map((item, idx) => (
      <div key={idx} className="bg-[#0B0E14] p-8">
        <p className="font-serif text-4xl leading-none tracking-tight text-[#EDE4D3]">
          {item.value}
        </p>
        <p className="mt-3 text-[11px] uppercase tracking-[0.22em] text-[#EDE4D3]/55">
          {item.label}
        </p>
      </div>
    ))}
  </div>
);

export default MetricRow;
